export default {
  path: 'quotes',
  name: 'quote',
};
